import { Box, Flex, Grid, ModalFooter, useToast } from "@chakra-ui/react";
import { ButtonCustom } from "../../form/controls/form.button";
import { Modal } from "../Modal";
import { TextAreaInput } from "../../form/controls/text-area.input";
import { useEffect, useState } from "react";
import { successToast } from "../../../constants/toast.constants";
import { Loading } from "../../shared/Loading";
import { DropdownInput } from "../../form/controls/dropdown.input";
import { InternalJobStatus } from "../../../models/enum/job-status.enum";
import { CompanyService } from "../../../service/company/company.service";
import { JobService } from "../../../service/job/job.service";
import { UserService } from "../../../service/user/user.service";
import { companyUserService } from "../../../service/company/company-user.service";
import { Region } from "../../../models/enum/region.enum";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

export const EditInternalJobModal = ({ isOpen, onClose, onSubmit, job }) => {
  const companyService = new CompanyService();
  const jobService = new JobService();
  const userService = new UserService();

  const toast = useToast();
  const { isManager } = useSelector((state: RootState) => state.userProfile);
  const [formState, setFormState] = useState({} as any);
  const [loading, setLoading] = useState(false);
  const [companyDropdown, setCompanyDropdown] = useState([] as any);
  const [userDropdown, setUserDropdown] = useState([] as any);
  const [adminUserDropdown, setAdminUserDropdown] = useState([] as any);
  const [warningModalOpen, setWarningModalOpen] = useState(false);

  const onInputChange = (event: any) => {
    let { name, value } = event.target;

    if (value === "") value = null;

    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleSubmit = async (e: any, isWarning: boolean = true) => {
    e.preventDefault();
    setLoading(true);

    const obj = { ...job, ...formState };

    if (obj.status === "COMPLETE" && isWarning) {
      setWarningModalOpen(true);
      setLoading(false);
      return;
    }

    await jobService
      .update({
        id: obj.id,
        status: obj.status,
        startDate: obj.startDate,
        notes: obj.notes,
        companyId: obj.companyId,
        weight: obj.weight,
        contactUserId: obj.contactUserId,
        rebateRequired: obj.rebateRequired,
        rebateReady: obj.rebateReady,
        showWasteImpact: obj.showWasteImpact,
        assignedAdminId: obj.assignedAdminId,
        region: obj.region,
        jobNumber: obj.jobNo,
      })
      .then(() => {
        toast(successToast("Job edited successfully."));
        handleClose();
        onSubmit({ ...job, ...formState });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClose = () => {
    setFormState({});
    setWarningModalOpen(false);
    onClose();
  };

  const initDropdowns = async () => {
    const dropdown = await companyService.getListForDropdown();
    setCompanyDropdown(dropdown);

    const users = await companyUserService.getUsers(job.companyId);
    let obj = {};

    users.forEach((user) => {
      if (!user.deleted) {
        obj[user.id] = `${user.firstName} ${user.lastName} <${user.email}>`;
      }
    });

    setUserDropdown(obj);
  };

  const initAdminUserDropdown = async () => {
    const users = await userService.getUsers();
    let obj = {};

    users
      .filter((x) => !x.deleted)
      .forEach((user) => {
        obj[user.id] = `${user.email}`;
      });

    setAdminUserDropdown(obj);
  };

  useEffect(() => {
    initAdminUserDropdown();
  }, []);

  useEffect(() => {
    if (job.companyId) {
      initDropdowns();
    }
    return () => {};
  }, [job.companyId]);

  return (
    <Modal
      isOpen={isOpen}
      header={`Edit INTERNAL-${job.jobNo}`}
      onClose={handleClose}
      width="650px"
    >
      <Loading loading={loading} fill ignoreDelay />
      <form onSubmit={handleSubmit}>
        <Flex flexDir="column" gap="12px">
          <Grid templateColumns="repeat(2, 1fr)" gap={2} rowGap={6}>

            <DropdownInput
              name="status"
              title="Status"
              options={InternalJobStatus}
              defaultValue={job.status}
              onChange={onInputChange}
            />
            <DropdownInput
              required
              name="region"
              title="Region"
              options={Region}
              defaultValue={job.region}
              onChange={onInputChange}
            />
            <DropdownInput
              name="contactUserId"
              title="Contact user"
              options={userDropdown}
              defaultValue={job.contactUserId}
              onChange={onInputChange}
            />
            <DropdownInput
              name="assignedAdminId"
              title="ZOLO Champion"
              options={adminUserDropdown}
              defaultValue={job.assignedAdminId}
              onChange={onInputChange}
            />
            {/* <FormInput
              required
              name="weight"
              title="Weight (kg)"
              type="number"
              defaultValue={job.weight}
              onChange={onInputChange}
            /> */}
          </Grid>
          <TextAreaInput
            title="Additional info"
            name="notes"
            defaultValue={job.notes}
            onChange={onInputChange}
          />

          <ModalFooter>
            <Flex gap="12px">
              <ButtonCustom secondary neutral onClick={onClose}>
                Cancel
              </ButtonCustom>
              <ButtonCustom type="submit">Confirm</ButtonCustom>
            </Flex>
          </ModalFooter>
        </Flex>
      </form>

      <Modal
        header="Wait - are you sure?"
        isOpen={warningModalOpen}
        onClose={() => setWarningModalOpen(false)}
      >
        <Box>
          If you close this Job, any Inventory items the user can see in Single
          Touch (under 'Ready for Disposal') will be hidden from them.
          <br />
          <br />
          <Flex justifyContent="flex-end" gap="6px">
            <ButtonCustom neutral onClick={() => setWarningModalOpen(false)}>
              Cancel
            </ButtonCustom>
            <ButtonCustom danger neutral onClick={(e) => handleSubmit(e,false)}>
              I understand, close job
            </ButtonCustom>
          </Flex>
        </Box>
      </Modal>
    </Modal>
  );
};
